exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-header {\n  color: #225cbd;\n  background: white;\n  padding: 10px;\n  font-weight: lighter;\n}\n.infoHover:hover > .personalizedTooltip {\n  display: block !important;\n}\n.parent {\n  position: relative;\n}\n.personalizedTooltip {\n  display: none;\n  position: absolute;\n  width: 300px;\n  border: 1px solid #00000063;\n  box-shadow: 0px 0px 24px -7px #00000099;\n}\n.personalizedTooltip .card {\n    font-weight: lighter;\n    margin: 0;\n    padding: 10px 20px;\n}\n.top-right {\n  bottom: 19px;\n  left: 6px;\n  z-index: 9999;\n}\n.top-left {\n  bottom: 19px;\n  right: 6px;\n  z-index: 9999;\n}\n", ""]);

// exports
